import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

import { OwlOptions } from 'ngx-owl-carousel-o';

import { HotMarket } from '@app/models';
import { HotMarketService } from '@app/services';

@Component({
    selector: 'hot-market-carousel',
    templateUrl: './hot-market-carousel.component.html',
    styleUrls: ['./hot-market-carousel.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HotMarketCarouselComponent {
  @Input() marketsPassedIn: HotMarket[];

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    autoHeight: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    navText: [ '<', '>' ],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      1240: {
        items: 3
      }
    },
    nav: true
  }

  // Carousel configuration
  carouselHeight: number = 350;
  numberOfImagesToDisplay: number = 3;
  imageAmountToScroll: number = 3;
  overflowImageLimit: number = 3;
  lazyLoadOverflowedImages: boolean = true;

  constructor(
    private _router: Router,
    private _hotMarketService: HotMarketService,
  ) {}

  goToHotMarketDetails(_market) {
    if (_market != undefined && _market._id != undefined) {
      this._hotMarketService.setHotMarketToBeViewed(_market);
      const nameParam = (_market.name != undefined) ? _market.name.replace(/\s+/g, '-').toLowerCase() : 'unknown';
      this._router.navigate(['/hot-markets/' + nameParam]);
    }
  }
}